import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseHttpService } from '../../abstracts/base-http-service.abstract';
import {
  AddUserRequest,
  AddUserResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
  EditProfileRequest,
  EditProfileResponse,
  EditUserRequest,
  EditUserResponse,
  EditUserRoleMenuRequest,
  EditUserRoleMenuResponse,
  GetUserListRequest,
  GetUserListResponse,
  GetUserMenuAccessListRequest,
  GetUserMenuAccessListResponse,
  GetUserProfileRequest,
  GetUserProfileResponse,
  GetUserRequest,
  GetUserResponse
} from './user.model';
import {
  AddUserRoleRequest,
  AddUserRoleResponse,
  EditUserRoleRequest,
  EditUserRoleResponse,
  GetUserRoleListRequest,
  GetUserRoleListResponse,
  GetUserRoleRequest,
  GetUserRoleResponse
} from './userRole.model';

const BASE_URL = '/api/v1/Account';

@Injectable({
  providedIn: 'root'
})
export class UserApiService extends BaseHttpService {
  AddUser(data: AddUserRequest): Observable<AddUserResponse> {
    return this.httpPost(`${BASE_URL}/AddUser`, data);
  }
  EditUser(data: EditUserRequest): Observable<EditUserResponse> {
    return this.httpPost(`${BASE_URL}/EditUser`, data);
  }
  GetUserList(data: GetUserListRequest): Observable<GetUserListResponse> {
    return this.httpPost(`${BASE_URL}/GetUserList`, data);
  }
  GetUser(data: GetUserRequest): Observable<GetUserResponse> {
    return this.httpPost(`${BASE_URL}/GetUser`, data);
  }
  AddUserRole(data: AddUserRoleRequest): Observable<AddUserRoleResponse> {
    return this.httpPost(`${BASE_URL}/AddUserRole`, data);
  }
  EditUserRole(data: EditUserRoleRequest): Observable<EditUserRoleResponse> {
    return this.httpPost(`${BASE_URL}/EditUserRole`, data);
  }
  GetUserRole(data: GetUserRoleRequest): Observable<GetUserRoleResponse> {
    return this.httpPost(`${BASE_URL}/GetUserRole`, data);
  }
  GetUserRoleList(data: GetUserRoleListRequest): Observable<GetUserRoleListResponse> {
    return this.httpPost(`${BASE_URL}/GetUserRoleList`, data);
  }
  GetUserMenuAccessList(data: GetUserMenuAccessListRequest): Observable<GetUserMenuAccessListResponse> {
    return this.httpPost(`${BASE_URL}/GetMenuAccessList`, data);
  }
  EditUserRoleMenu(data: EditUserRoleMenuRequest): Observable<EditUserRoleMenuResponse> {
    return this.httpPost(`${BASE_URL}/EditUserRoleMenu`, data);
  }
  ChangePassword(data: ChangePasswordRequest): Observable<ChangePasswordResponse> {
    return this.httpPost(`${BASE_URL}/ChangePassword`, data);
  }
  EditProfile(data: EditProfileRequest): Observable<EditProfileResponse> {
    return this.httpPost(`${BASE_URL}/EditProfile`, data);
  }
  GetUserProfile(data: GetUserProfileRequest): Observable<GetUserProfileResponse> {
    return this.httpPost(`${BASE_URL}/GetUserProfile`, data);
  }
}
